const favouriteAzkarData = {
  title: "الأذكار المفضلة",
  List: [
    {
      id: 1,
      name: "أذكار بعد الصلاة",
      path: "/after-salah",
    },
    {
      id: 2,
      name: "أذكار الصباح",
      path: "/azkar-alsbah",
    },
    {
      id: 3,
      name: "أذكار المساء",
      path: "/azkar-almsaa",
    },
    {
      id: 4,
      name: "أذكار النوم",
      path: "/azkar-alnoom",
    },
    {
      id: 5,
      name: "الطعام والشراب",
      path: "/azkar-taam-shrab",
    },
    {
      id: 6,
      name: "الوضوء والصلاة",
      path: "/azkar-wdoua-salah",
    },
    {
      id: 7,
      name: "الحج والعمرة",
      path: "/azkar-haj-omrah",
    },
    {
      id: 8,
      name: "أذكار المنزل",
      path: "/azkar-almanzel",
    },
  ],
};

export default favouriteAzkarData;
